// #3512 -- where an Add Ride Manually ride lands. A tablet can keep an older
// show's class cached (the class page it is on was opened under a previous
// show), while the session is on a newer show. Posting that ride used to stamp
// the old show's class on it (prod, HITS Del Mar Spooktacular, 2026-10-17: the
// July show's class and ring). The ride must go on the show the station is
// assigned to, which is the session's selected show.
//
// A class id is `<showId>:<fvd class key>` and two shows of one circuit repeat
// the same key, so when the class on screen belongs to another show, the
// equivalent class of the assigned show is the one with the same key. If that
// class cannot be found (offline with nothing cached, or the show has no such
// class) the ride is still created, on the assigned show, with the class the
// scribe was on: the server never refuses a scribe save and flags the
// disagreement for the Review Queue instead.
//
// Pure of React and of the network: `loadClasses(showId)` is injected.
export async function resolveManualRideTarget({ classId, klass, assignedShowId, loadClasses }) {
  const classShowId = klass?.showId ?? null;
  if (!assignedShowId) return { classId, showId: classShowId ?? undefined };
  if (!classShowId || classShowId === assignedShowId) {
    return { classId, showId: assignedShowId };
  }
  const prefix = `${classShowId}:`;
  if (classId.startsWith(prefix)) {
    const wanted = `${assignedShowId}:${classId.slice(prefix.length)}`;
    try {
      const list = await loadClasses(assignedShowId);
      const match = Array.isArray(list) ? list.find((c) => c?.id === wanted) : null;
      if (match) return { classId: match.id, showId: assignedShowId };
    } catch {
      // Fall through: the emergency path never waits on a lookup.
    }
  }
  return { classId, showId: assignedShowId };
}
